import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import moment from "moment";

import { title, List } from "utils";
import { Horloge, CarouselPhotos } from "components/";
import { Counter } from "components/_charts";
import { icons } from "constants/icons";
import { statsService, projectService, clientService } from "services";
import { optionService } from "services/option.service";
import { Icon, Select } from "antd";
import TailgateGrid from "components/TailgateGrid";

const { Option, OptGroup } = Select;

class HomeTv2Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directionMessage: "",
      counts_year: [],
      counts_week: [],
      carouselKey: 0,
      gridKey: 0,
      sseKey: 0,
      filter: null,
      projects: [],
      clients: [],
    };
    this.fetchStats = this.fetchStats.bind(this);
    this.refreshAll = this.refreshAll.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchStats();
    this.fetchFilterOptions();
    optionService.get("tv_message").then((value) => {
      this.setState({ directionMessage: value || "" });
    }).catch(() => {});
    this.refreshTimer = setInterval(() => this.refreshAll(), 900000);
  }

  fetchFilterOptions() {
    projectService.list({ per_page: 100 }).then((res) => {
      this.setState({ projects: res.data || res || [] });
    }).catch(() => {});
    clientService.list({ per_page: 100 }).then((res) => {
      this.setState({ clients: res.data || res || [] });
    }).catch(() => {});
  }

  handleFilter(value) {
    this.setState({ filter: value || null }, () => {
      this.fetchStats();
      this.setState((prev) => ({
        carouselKey: prev.carouselKey + 1,
        sseKey: prev.sseKey + 1,
      }));
      if (this.wrapRef) this.wrapRef.scrollTop = 0;
    });
  }

  getFilterParams() {
    const { filter } = this.state;
    if (!filter) return {};
    const [type, id] = filter.split("-");
    return type === "c" ? { client_id: id } : { project_id: id };
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.refreshTimer);
  }

  async refreshAll() {
    const delay = (ms) => new Promise((r) => setTimeout(r, ms));
    const ops = [
      () => this.setState((prev) => ({ carouselKey: prev.carouselKey + 1 })),
      () => this.setState((prev) => ({ gridKey: prev.gridKey + 1 })),
      () => this.setState((prev) => ({ sseKey: prev.sseKey + 1 })),
      () => this.fetchStats(),
      async () => {
        const value = await optionService.get("tv_message");
        this.setState({ directionMessage: value || "" });
      },
    ];

    for (const op of ops) {
      if (!this._isMounted) return;
      try { await op(); } catch (_) {}
      await delay(500);
    }
  }

  fetchStats() {
    const year_begin = moment().startOf("year").format("YYYY-MM-DD");
    const week_begin = moment().startOf("week").format("YYYY-MM-DD");
    const today = moment().add(1, "day").endOf("day").format("YYYY-MM-DD");
    const fp = this.getFilterParams();
    const extra = Object.entries(fp).map(([k, v]) => `${k}=${v}`).join("&");
    const sep = extra ? "&" : "";

    statsService
      .stats_tv("date[]=" + year_begin + "&date[]=" + today + sep + extra)
      .then((result) => this.setState({ counts_year: result }))
      .catch(() => {});

    statsService
      .stats_tv("date[]=" + week_begin + "&date[]=" + today + sep + extra)
      .then((result) => this.setState({ counts_week: result }))
      .catch(() => {});
  }

  render() {
    const { directionMessage, counts_year, counts_week, carouselKey, gridKey, sseKey, filter, projects, clients } = this.state;
    const filterParams = this.getFilterParams();

    return (
      <div className="homeTv2-page-wrap" ref={(el) => this.wrapRef = el}>
        <Helmet>{title("Accueil TV v2")}</Helmet>
        <div className="homeTv2-page main-content">
          {/* ── Carousel with centered clock overlay ── */}
          <div className="tv2-carousel-wrap">
            <div key={"carousel-" + carouselKey} className="tv2-fade">
              <CarouselPhotos spacer filters={filterParams} />
            </div>
            <div className="tv2-banner-clock">
              <Horloge />
            </div>
          </div>

          <div className="tv2-top">
            <div className="tv2-left">
              <div className="tv2-tailgate-box">
                <div key={"tg-" + gridKey} className="tv2-fade">
                  <TailgateGrid />
                </div>
              </div>

              {directionMessage && (
                <div className="tv2-direction-box">
                  <div className="tv2-dm-label">Message de la direction :</div>
                  <div className="tv2-dm-text">{directionMessage}</div>
                </div>
              )}
            </div>

            {/* Right column */}
            <div className="tv2-right">
              <div className="tv2-cards-grid">
                <div key={"sse-" + sseKey} className="tv2-fade">
                  <List type="sse" filters={{ type_id: 2, page_number: 1, per_page: 4, order_by: "date,id", order_direction: "DESC,DESC", ...filterParams }} cards tv />
                </div>
              </div>

              <div className="tv2-stats">
                <article className="tv2-stat-item">
                  <h2><Icon type={icons.sse} /> Interventions SSE de la semaine</h2>
                  <Counter data={counts_week.intervention_count} />
                </article>
                <article className="tv2-stat-item">
                  <h2><Icon type={icons.sse} /> Interventions SSE de l'année</h2>
                  <Counter data={counts_year.intervention_count} />
                </article>
                <article className="tv2-stat-item">
                  <h2><Icon type={icons.tailgate} /> Tailgates de la semaine</h2>
                  <Counter data={counts_week.tailgate_count} />
                </article>
                <article className="tv2-stat-item">
                  <h2><Icon type={icons.tailgate} /> Tailgates de l'année</h2>
                  <Counter data={counts_year.tailgate_count} />
                </article>
              </div>
            </div>
          </div>

        </div>

        <div className="tv2-filter">
          <Icon type="filter" />
          <Select
            allowClear
            showSearch
            placeholder="Filtrer par client ou projet..."
            value={filter || undefined}
            onChange={this.handleFilter}
            style={{ width: 400 }}
            filterOption={(input, option) => {
              const children = option.props.children;
              const text = Array.isArray(children) ? children.join("") : String(children || "");
              return text.toLowerCase().includes(input.toLowerCase());
            }}
          >
            <OptGroup label="Clients">
              {clients.map((c) => (
                <Option key={"c-" + c.id} value={"c-" + c.id}>
                  {c.name}
                </Option>
              ))}
            </OptGroup>
            <OptGroup label="Projets">
              {projects.map((p) => (
                <Option key={"p-" + p.id} value={"p-" + p.id}>
                  {p.code} - {p.label}
                </Option>
              ))}
            </OptGroup>
          </Select>
        </div>
      </div>
    );
  }
}

export default HomeTv2Page;
